import { configureStore } from "@reduxjs/toolkit";
import passportReducer from "../features/passport/passportSlice";
import visaReducer from "../features/visa/visaSlice";
import officeReducer from "../features/deliveryoffice/officeSlice";
import agentReducer from "../features/agent/agentSlice";
import employeeReducer from "../features/employee/employeeSlice";
import userReducer from "../features/user/userSlice";
import salaryReducer from "../features/salary/salarySlice";
import dailyExpenseReducer from "../features/dailyexpense/dailyExpenseSlice";
import duecollectionReducer from "../features/duecollection/duecollectionSlice";
import incomeReducer from "../features/income/incomeSlice";

export const store = configureStore({
  reducer: {
    passport: passportReducer,
    visa: visaReducer,
    office: officeReducer,
    agent: agentReducer,
    employee: employeeReducer,
    user: userReducer,
    salary: salaryReducer,
    dailyExpense: dailyExpenseReducer,
    duecollection: duecollectionReducer,
    income: incomeReducer,
  },
});
